import { TrafficLight } from '@mgdlead/ui';

import { useWorkspace } from '../workspace/WorkspaceContext';
import { useGoalsOverview } from '../../lib/api';

/**
 * G3 — o semáforo da META do bloco ao lado do nome (lista e cards de campanha).
 *
 * A cor é o pior indicador com meta, decidido no servidor; a dica lista cada indicador
 * colorido ("Meta: até 20% · Agora: 26% · Fora da meta"). Bloco sem meta não ganha semáforo
 * (spec G3: só o número) — e o componente não desenha nada.
 */
export function CampaignGoalLight({ campaignId }: { campaignId: string }) {
  const { workspace } = useWorkspace();
  const overview = useGoalsOverview(workspace.id);
  const bloco = overview.data?.campanhas.find((c) => c.campaignId === campaignId);
  if (!bloco || bloco.pior === null) return null;
  const dica = bloco.indicadores
    .filter((i) => i.semaforo !== null && i.dica !== null)
    .map((i) => `${i.rotulo} — ${i.dica}`)
    .join('\n');
  return <TrafficLight status={bloco.pior} hint={dica || undefined} />;
}
